import { manufacturingFetch } from "@/lib/manufacturingClient";

export function lookupLogisticsSerialStatus(serial: string, ask = false) {
  return manufacturingFetch<{
    ok: true;
    label: string;
    sent: number;
    snapshot: { found: boolean; serial: string; phase: string; inspection: string; session_id: string | null };
  }>("/api/logi/serial-status", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ serial, ask }),
  });
}
